import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

const reportsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.all_reports_trans',
  route: { name: 'reports' },
});

const reports_routes = [
  {
    path: '/reports',
    name: 'reports',
    meta: {
      header: {
        title: 'GLOBAL.NAVS.all_reports_trans',
        icon: 'bvi-presentation-chart-bar',
      },
      sidebar: [
        {
          icon: 'bvi-circle-chat-bubbles',
          title: 'global.sidebar.conversations_reports_trans',
          route: { name: 'conversation-reports' },
          permissions: 'read-conversation-reports',
        },
        {
          icon: 'bvi-message-response',
          title: 'global.sidebar.responses_reports_trans',
          route: { name: 'responses-reports' },
          permissions: 'read-response-reports',
        },
        {
          icon: 'bvi-message-tick',
          title: 'global.sidebar.resolution_reports_trans',
          route: { name: 'resolution-reports' },
          permissions: 'read-resolution-reports',
        },
        {
          icon: 'bvi-contacts',
          title: 'global.sidebar.contacts_reports_trans',
          route: { name: 'contacts-reports' },
          permissions: 'read-contact-reports',
        },
        {
          icon: 'bvi-messages',
          title: 'global.sidebar.messages_reports_trans',
          route: { name: 'messages-reports' },
          permissions: 'read-message-reports',
        },
        {
          icon: 'bvi-broadcast',
          title: 'global.sidebar.broadcast_reports_trans',
          route: { name: 'broadcast-reports' },
          permissions: 'read-broadcast-reports',
        },
        {
          icon: 'bvi-user-group',
          title: 'global.sidebar.users_reports_trans',
          route: { name: 'users-reports' },
          permissions: 'read-user-reports',
        },
        {
          icon: 'bvi-face-happy ',
          title: 'global.sidebar.csat_reports_trans',
          route: { name: 'csat-reports' },
          permissions: 'read-csat-reports',
        },
      ],
    },
    children: [
      {
        path: 'conversation',
        name: 'conversation-reports',
        component: () => import('@/views/System/Reports/Pages/ConversationView.vue'),
        meta: {
          permissions: 'read-conversation-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.conversations_reports_trans',
            route: { name: 'conversation-reports' },
          }),
        },
      },
      {
        path: 'responses',
        name: 'responses-reports',
        component: () => import('@/views/System/Reports/Pages/ResponsesView.vue'),
        meta: {
          permissions: 'read-response-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.responses_reports_trans',
            route: { name: 'responses-reports' },
          }),
        },
      },
      {
        path: 'resolution',
        name: 'resolution-reports',
        component: () => import('@/views/System/Reports/Pages/ResolutionView.vue'),
        meta: {
          permissions: 'read-resolution-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.resolution_reports_trans',
            route: { name: 'resolution-reports' },
          }),
        },
      },
      {
        path: 'contacts',
        name: 'contacts-reports',
        component: () => import('@/views/System/Reports/Pages/ContactsView.vue'),
        meta: {
          permissions: 'read-contact-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.contacts_reports_trans',
            route: { name: 'contacts-reports' },
          }),
        },
      },
      {
        path: 'messages',
        name: 'messages-reports',
        component: () => import('@/views/System/Reports/Pages/MessagesView.vue'),
        meta: {
          permissions: 'read-message-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.messages_reports_trans',
            route: { name: 'messages-reports' },
          }),
        },
      },
      {
        path: 'broadcast',
        name: 'broadcast-reports',
        component: () => import('@/views/System/Reports/Pages/BroadcastView.vue'),
        meta: {
          permissions: 'read-broadcast-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.broadcast_reports_trans',
            route: { name: 'broadcast-reports' },
          }),
        },
      },
      {
        path: 'users',
        name: 'users-reports',
        component: () => import('@/views/System/Reports/Pages/UsersView.vue'),
        meta: {
          permissions: 'read-user-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.users_reports_trans',
            route: { name: 'users-reports' },
          }),
        },
      },
      {
        path: 'csat',
        name: 'csat-reports',
        component: () => import('@/views/System/Reports/Pages/CsatView.vue'),
        meta: {
          permissions: 'read-csat-reports',
          breadcrumbs: reportsBreadcrumbs({
            label: 'global.sidebar.csat_reports_trans',
            route: { name: 'csat-reports' },
          }),
        },
      },
    ],
  },
];

export default reports_routes;
